import { createContext, type ReactNode, useContext } from 'react';

import { usePolicyOnDashboard } from './usePolicyOnDashboard';

const TimeZoneContext = createContext<string | undefined>(undefined);

/** Contract date-times below this point are typed and shown in the policy's zone. */
export function PolicyTimeZoneProvider({ children }: { children: ReactNode }) {
  const { policy } = usePolicyOnDashboard();
  return <TimeZoneContext.Provider value={policy.timeZone}>{children}</TimeZoneContext.Provider>;
}

/** The policy's zone on a policy page, undefined elsewhere. */
export const useContractTimeZone = () => useContext(TimeZoneContext);

/** The policy's zone on a policy page, the device's elsewhere. */
export const useTimeZone = () =>
  useContractTimeZone() ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
